import React from 'react';
import Chart from 'react-apexcharts';

const MemoryUsageChart = ({ data }) => {
    const options = {
        chart: { type: 'line', toolbar: { show: false } },
        xaxis: { categories: data.map(d => d.path || 'Unknown API') },
        colors: ['#8e44ad', '#3498db'],
        stroke: { curve: 'smooth', width: 3 },
        markers: { size: 4 },
        yaxis: {
            labels: {
                formatter: function (val) {
                    return val ? val.toFixed(2) : "0";
                }
            }
        },
        tooltip: {
            x: {
                formatter: function(val, { dataPointIndex }) {
                    const req = data[dataPointIndex];
                    if (!req) return val;
                    const date = new Date(req.timestamp).toLocaleString();
                    return `${req.path} - ${date}`;
                }
            },
            y: {
                formatter: function (val) {
                    return val ? val.toFixed(2) + " MB" : "0 MB";
                }
            }
        },
        legend: {
            position: 'top'
        }
    };

    const series = [
        { name: 'RSS Delta (MB)', data: data.map(d => d.memory?.delta?.rss || 0) },
        { name: 'Heap Used Delta (MB)', data: data.map(d => d.memory?.delta?.heapUsed || 0) }
    ];

    return (
        <div className="chart-card">
            <h3>API Memory Usage Trend</h3>
            <Chart options={options} series={series} type="line" height={300} />
            <p style={{ fontSize: '12px', color: '#7f8c8d', marginTop: '10px' }}>
                * Note: The memory delta is a correlation/snapshot difference, NOT exact per-request memory consumption because Node.js memory is shared and garbage collection is asynchronous.
            </p>
        </div>
    );
};

export default MemoryUsageChart;
